import React from 'react';
import { useLocation } from 'react-router-dom';
import LineaNegocioForm from '../components/tabForms/LineaNegocioForm';
import { Container } from '@mui/material';

const LineaNegocioPage = () => {
    const location = useLocation();
    const { customer }  = location.state || {};  // Acceder a los datos del cliente

    return (
        <Container maxWidth="lg">
            {/* Pasar los datos del cliente como props al formulario */}
            <LineaNegocioForm customer={customer} />
        </Container>
    );
};

export default LineaNegocioPage;
